// Textos de Admin › Eventos (catálogo de eventos y sus categorías). Se
// registran junto al resto de vocabularios en AppComponent; setTranslation los
// fusiona (también SIDEBAR y PAGE_HEADER).
export const locale = {
  lang: 'ca',
  data: {
    SIDEBAR: {
      EVENTS_SECTION: 'Esdeveniments',
      EVENTS: 'Esdeveniments',
      EVENT_CATEGORIES: "Categories d'esdeveniments",
    },
    PAGE_HEADER: {
      EVENTS: 'Concerts, partits, festivals… als quals els usuaris creen viatges. Dona d’alta, edita, cancel·la o reactiva cada esdeveniment.',
      EVENT_CATEGORIES: 'Les categories que es trien en donar d’alta un esdeveniment i el seu nom en cada idioma.',
      EVENTS_TICKETMASTER: 'Esdeveniments de Ticketmaster a Espanya dels propers dies. Tria els que vulguis i afegeix-los al catàleg d’una vegada.',
    },
    EVENTS: {
      LOADING: 'Carregant…',
      RETRY: 'Torna-ho a provar',
      SAVE: 'Desa',
      SAVE_CHANGES: 'Desa els canvis',
      SAVING: 'Desant…',
      DELETING: 'Eliminant…',
      PREVIOUS: 'Anterior',
      NEXT: 'Següent',
      COL_STATUS: 'Estat',
      COL_ACTIONS: 'Accions',
      FIELD_REQUIRED: 'Aquest camp és obligatori.',
      GENERIC_ERROR: "Hi ha hagut un error. Torna-ho a provar d'aquí a uns minuts.",
      STATUS: {
        active: 'Actiu',
        cancelled: 'Cancel·lat',
      },
      LEGACY: {
        concert: 'Concert',
        sport: 'Esport',
        festival: 'Festival',
        fair: 'Fira',
        theatre: 'Teatre',
        other: 'Altres',
      },
      SOURCE: {
        backoffice: 'Dashboard',
        ticketmaster: 'Ticketmaster',
      },
      LIST: {
        ADD: 'Nou esdeveniment',
        IMPORT_TICKETMASTER: 'Importar de Ticketmaster',
        IMPORT_FOOTBALL_DATA: 'Importar Primera Divisió',
        PANEL_TITLE: 'Propers esdeveniments',
        PANEL_TITLE_ALL: 'Tots els esdeveniments',
        PANEL_SUB: 'Ordenats per data. L’hora és la del recinte. Sense «Inclou els passats», només surten els que no han acabat.',
        SEARCH: 'Cerca per nom o artista…',
        STATUS_ALL: 'Tots els estats',
        FILTER_CATEGORIES: 'Categories',
        FILTER_CITY: 'Ciutat',
        FILTER_FROM: 'Des de',
        FILTER_TO: 'Fins a',
        FILTER_PAST: 'Esdeveniments passats',
        FILTER_INCLUDE_PAST: 'Inclou els passats',
        DATES_INVALID: 'La data «Fins a» no pot ser anterior a «Des de».',
        CHIP_BETWEEN: 'Del {{from}} al {{to}}',
        CHIP_FROM: 'Des del {{from}}',
        CHIP_TO: 'Fins al {{to}}',
        REMOVE_FILTER: 'Treu el filtre {{label}}',
        COL_DATE: 'Data',
        COL_EVENT: 'Esdeveniment',
        COL_CATEGORY: 'Categoria',
        COL_PLACE: 'Lloc',
        COL_TRIPS: 'Viatges',
        EMPTY: 'No hi ha propers esdeveniments.',
        EMPTY_FILTERED: 'Cap esdeveniment no coincideix amb els filtres.',
        LOAD_ERROR: "No s'han pogut carregar els esdeveniments.",
        SHOWING: 'Mostrant {{shown}} de {{total}} esdeveniments',
        PER_PAGE: '{{count}} per pàgina',
        PER_PAGE_ARIA: 'Esdeveniments per pàgina',
      },
      TICKETMASTER: {
        TITLE: 'Importar de Ticketmaster',
        PANEL_TITLE: 'Esdeveniments a Ticketmaster',
        PANEL_SUB: 'A Espanya, d’avui al {{until}} ({{days}} dies). L’hora és la del recinte. Pots triar esdeveniments de diverses pàgines.',
        PANEL_SUB_GENERIC: 'A Espanya, d’avui als propers dies. L’hora és la del recinte.',
        SEARCH: 'Cerca per nom, artista o recinte…',
        LOAD_ERROR: 'No s’han pogut carregar els esdeveniments de Ticketmaster.',
        EMPTY: 'Ticketmaster no té esdeveniments per a aquestes dates.',
        EMPTY_FILTERED: 'Cap esdeveniment de Ticketmaster coincideix amb la cerca.',
        SHOWING: 'Es mostren {{shown}} de {{total}} espectacles ({{dates}} dates)',
        SELECT_PAGE: 'Triar tots els d’aquesta pàgina',
        SELECT_ROW: 'Triar «{{name}}»',
        SELECT_GROUP: 'Triar totes les dates de «{{name}}»',
        DATES: '{{count}} dates',
        DATES_RANGE: 'Del {{from}} al {{to}}',
        SHOW_DATES: 'Veure les dates',
        HIDE_DATES: 'Amagar les dates',
        GROUP_IN_CATALOG: '{{count}} al catàleg',
        TIME_TBD: 'Hora per confirmar',
        TIME_TBD_HINT: 'Ticketmaster encara no ha donat l’hora. Es desarà a les 00:00: corregeix-la a la fitxa de l’esdeveniment quan se sàpiga.',
        NO_VENUE: 'Sense recinte',
        IN_CATALOG: 'Al catàleg',
        IN_CATALOG_HINT: 'Ja és al catàleg.',
        CANCELLED_HINT: 'Està cancel·lat a Ticketmaster.',
        MISSING: 'Ticketmaster no dona totes les dades (falta: {{fields}}). Si el necessites, crea’l a mà des de «Nou esdeveniment».',
        INCOMPLETE: 'Dades incompletes',
        INVALID: 'No s’ha afegit',
        INVALID_HINT: 'El catàleg no l’ha acceptat. Revisa: {{fields}}.',
        EXTERNAL_ID: 'Identificador de Ticketmaster',
        OPEN_TM: 'Veure a Ticketmaster',
        SELECTION: 'Esdeveniments triats',
        SELECTED: 'Esdeveniments triats: {{count}}',
        NEEDS_CATEGORY: 'Tria la categoria dels marcats en vermell ({{count}}).',
        CLEAR_SELECTION: 'Treure la selecció',
        IMPORT: 'Afegir al catàleg ({{count}})',
        IMPORTING: 'S’estan afegint…',
        IMPORT_ERROR: 'No s’han pogut afegir els esdeveniments',
        RESULT_CREATED: 'Esdeveniments afegits al catàleg: {{count}}',
        RESULT_NONE_NEW: 'Els esdeveniments triats ja eren al catàleg',
        RESULT_PARTIAL: 'S’han afegit {{created}} de {{sent}} esdeveniments al catàleg',
        RESULT_FAILED: 'No s’ha afegit cap esdeveniment al catàleg',
        RESULT_EXISTING: 'Ja hi eren: {{count}}.',
        RESULT_INVALID: 'Amb errors: {{count}} (marcats a la taula).',
        GO_TO_EVENTS: 'Veure esdeveniments',
        KEEP_IMPORTING: 'Continuar important',
        TM_STATUS: {
          offsale: 'Sense venda',
          cancelled: 'Cancel·lat a Ticketmaster',
          canceled: 'Cancel·lat a Ticketmaster',
          postponed: 'Ajornat',
          rescheduled: 'Canvi de data',
        },
      },
      FOOTBALL_DATA: {
        CONFIRM_TITLE: 'Vols importar els partits de Primera?',
        CONFIRM_TEXT: 'Es porten de football-data els partits de Primera Divisió dels propers dies que ja tenen hora oficial. Els que ja són al catàleg s’actualitzen si l’hora ha canviat.',
        CONFIRM: 'Importar partits',
        IMPORTING: 'S’està important…',
        DONE: 'Importats',
        RESULT_TITLE: 'Partits nous: {{created}} · amb hora nova: {{updated}}',
        RESULT_NONE: 'No hi ha partits nous ni canvis d’hora',
        UNCHANGED: 'Ja hi eren i sense canvis: {{count}}.',
        UNCONFIRMED: 'Encara sense hora oficial: {{count}}. Es portaran en tornar a importar quan la tinguin.',
        CONFLICTS: 'Han canviat d’hora però tenen viatges pendents, així que no s’han mogut ({{count}}). Revisa’ls a la fitxa:',
        CONFLICT_ITEM: '{{name}}: {{now}} → {{next}}',
        SKIPPED: 'Sense estadi conegut, no s’han portat ({{count}}): {{names}}.',
        WINDOW: 'Partits fins al {{until}} ({{days}} dies). Les hores, en hora de Madrid.',
      },
      DETAIL: {
        TITLE: "Detall de l'esdeveniment",
        NEW_TITLE: 'Nou esdeveniment',
        BACK: 'Torna al llistat',
        CREATE: "Crea l'esdeveniment",
        TRIPS: 'Viatges vinculats',
        PENDING_ROUTES: 'Trajectes per sortir',
        PENDING_USERS: 'Usuaris amb viatges',
        TIME_ZONE: 'Zona horària',
        SOURCE: 'Origen',
        SEE_LINKED: 'Mostra els viatges vinculats',
        CANCELLED_TITLE: 'Esdeveniment cancel·lat',
        CANCELLED_TEXT: "No apareix a l'app ni admet viatges nous. Els seus viatges pendents es cancel·len en segon pla, sense penalització, i cada usuari rep un avís.",
        LOAD_ERROR: "No s'ha pogut carregar l'esdeveniment.",
        SAVE_ERROR: "No s'ha pogut desar l'esdeveniment.",
        CREATED_TITLE: 'Esdeveniment creat',
        SAVED_TITLE: 'Canvis desats',
      },
      FORM: {
        SECTION_EVENT: 'Esdeveniment',
        SECTION_PLACE: 'Lloc',
        SECTION_WHEN: 'Data i hora',
        NAME: 'Nom',
        PERFORMER: 'Artista o equips',
        PERFORMER_HINT: 'Opcional. Per exemple, el grup o els equips del partit.',
        CATEGORY: 'Categoria',
        CATEGORY_PLACEHOLDER: 'Tria una categoria',
        CATEGORY_INACTIVE: '{{name}} (desactivada)',
        PLACE_SEARCH: "Cerca el recinte o l'adreça",
        PLACE_SEARCH_PLACEHOLDER: 'Estadi, sala, recinte firal…',
        PLACE_SEARCH_HINT: "En triar un lloc s'omplen el recinte, l'adreça, la ciutat i la ubicació. Després pots retocar els textos.",
        PLACE_LOCKED: "La ubicació no es pot canviar: l'esdeveniment té viatges que encara no han sortit.",
        VENUE: 'Recinte',
        ADDRESS: 'Adreça',
        CITY: 'Ciutat',
        LOCATION: 'Ubicació',
        SEE_MAP: 'Mostra al mapa',
        NO_LOCATION: 'Sense ubicació: tria el lloc al cercador.',
        LOCATION_REQUIRED: 'Tria el lloc al cercador per fixar la ubicació.',
        START_DATE: "Dia d'inici",
        START_TIME: "Hora d'inici",
        END_DATE: 'Dia de fi',
        END_TIME: 'Hora de fi',
        START_REQUIRED: "Indica el dia i l'hora d'inici.",
        END_TIME_REQUIRED: "Indica també l'hora de fi.",
        END_BEFORE_START: "La fi no pot ser anterior a l'inici.",
        TIME_ZONE: 'Zona horària del recinte',
        TIME_ZONE_HINT: "Les hores es desen en aquesta zona. Es posa sola en triar el lloc.",
        TZ_MADRID: 'Península, Balears, Ceuta i Melilla (Europe/Madrid)',
        TZ_CANARY: 'Canàries (Atlantic/Canary)',
        LOCKED_TITLE: 'Té viatges que encara no han sortit ({{routes}})',
        LOCKED_TEXT: "No es poden canviar la data, l'hora, la zona horària ni la ubicació. Si s'ha de moure, cancel·la'l (s'avisa els usuaris) i crea'n un de nou.",
        CHECK_FIELDS: 'Revisa els camps marcats.',
        NO_CHANGES: 'No has canviat res.',
      },
      LINKED: {
        TITLE: 'Viatges vinculats',
        SUB: "Trajectes d'usuaris cap a l'esdeveniment o des d'ell que encara no han sortit, un per fila.",
        EMPTY: 'No hi ha viatges pendents de sortir.',
        LOAD_ERROR: "No s'han pogut carregar els viatges vinculats.",
        COL_USER: 'Usuari',
        COL_ROLE: 'Rol',
        COL_LEG: 'Trajecte',
        COL_DEPARTURE: 'Sortida',
        COL_MATCH: 'Match',
        MATCHED: 'Amb match',
        NOT_MATCHED: 'Sense match',
        ROLE: {
          driver: 'Conductor',
          rider: 'Passatger',
        },
        LEG: {
          outbound: 'Anada',
          return: 'Tornada',
        },
        SUMMARY_OUTBOUND: 'Anada: {{count}}',
        SUMMARY_RETURN: 'Tornada: {{count}}',
        SUMMARY_DRIVERS: 'Conductors: {{count}}',
        SUMMARY_RIDERS: 'Passatgers: {{count}}',
        SUMMARY_MATCHED: 'Amb match: {{count}}',
      },
      ACTIONS: {
        CANCEL: "Cancel·la l'esdeveniment",
        KEEP: 'No el cancel·lis',
        CANCEL_TITLE: 'Cancel·la «{{name}}»',
        CANCEL_TEXT_NO_TRIPS: "No té viatges pendents. Deixarà d'aparèixer a l'app i no admetrà viatges nous.",
        CANCEL_SUMMARY_ROUTES: 'Trajectes que es cancel·len: <b>{{routes}}</b>',
        CANCEL_SUMMARY_USERS: 'Usuaris que reben un avís: <b>{{users}}</b>',
        CANCEL_SUMMARY_SPLIT: '<span class="bo-swal-muted">Anada {{outbound}} · tornada {{back}} · conductor {{drivers}} · passatger {{riders}}</span>',
        CANCEL_SUMMARY_NOTE: "Es cancel·len en segon pla i sense penalització. L'esdeveniment deixa d'aparèixer a l'app.",
        CANCELLING: 'Cancel·lant…',
        CANCELLED: 'Cancel·lat',
        REACTIVATE: "Reactiva l'esdeveniment",
        REACTIVATE_TITLE: 'Reactiva «{{name}}»',
        REACTIVATE_TEXT: "Tornarà a aparèixer a l'app i admetrà viatges nous. Els viatges que es van cancel·lar no es recuperen.",
        REACTIVATED: 'Reactivat',
        DELETE: "Elimina l'esdeveniment",
        DELETE_TITLE: 'Elimina «{{name}}»',
        DELETE_TEXT: 'Només per a esdeveniments sense viatges, per exemple un creat per error. No es pot desfer.',
        DELETED: 'Eliminat',
        DELETE_BLOCKED_TITLE: "No es pot eliminar l'esdeveniment",
        DELETE_BLOCKED_TEXT: 'Té viatges. El pots cancel·lar en el seu lloc.',
        ERROR_TITLE: "No s'ha pogut completar l'acció",
      },
      CATEGORIES: {
        ADD: 'Nova categoria',
        TABS_ARIA: 'Estat de la categoria',
        TAB_all: 'Totes',
        TAB_active: 'Actives',
        TAB_inactive: 'Desactivades',
        PANEL_TITLE_all: 'Totes les categories',
        PANEL_TITLE_active: 'Categories actives',
        PANEL_TITLE_inactive: 'Categories desactivades',
        PANEL_SUB: "En l'ordre en què surten a l'app. Les desactivades no es poden triar per a un esdeveniment nou; els que ja la tenen la conserven.",
        COL_NAME: 'Nom',
        COL_CODE: 'Codi',
        COL_LEGACY: 'Categoria general',
        COL_ORDER: 'Ordre',
        COL_EVENTS: 'Esdeveniments',
        ACTIVE: 'Activa',
        INACTIVE: 'Desactivada',
        BASE: 'Bàsica',
        BASE_HINT: 'Una de les 6 categories de sempre: no es pot eliminar.',
        EMPTY: 'No hi ha categories en aquesta vista.',
        LOAD_ERROR: "No s'han pogut carregar les categories.",
        EDIT: 'Edita la categoria',
        NEW_TITLE: 'Nova categoria',
        NEW_SUB: "Es podrà triar en donar d'alta un esdeveniment.",
        EDIT_TITLE: 'Edita la categoria',
        SECTION_NAME: 'Nom en cada idioma',
        SECTION_CLASSIFICATION: 'Classificació',
        NAME_ES: 'Castellà',
        NAME_EN: 'Anglès',
        NAME_CA: 'Català',
        CODE_HINT: 'Identificador estable: minúscules, números i «_». Es suggereix a partir del nom en castellà i després no es pot canviar.',
        CODE_LOCKED: 'El codi no es pot canviar.',
        CODE_INVALID: 'Només minúscules sense accents, números i «_», fins a 32 caràcters.',
        LEGACY_PLACEHOLDER: 'Tria la categoria general',
        LEGACY_HINT: "Categoria general a la qual pertany: és la que veuen les versions antigues de l'app. Després no es pot canviar.",
        LEGACY_LOCKED: 'La categoria general no es pot canviar.',
        ORDER_HINT: 'Posició als llistats (les més baixes primer).',
        ORDER_INVALID: 'Un nombre enter entre 0 i 100.000.',
        ACTIVE_CHECK: 'Activa',
        ACTIVE_HINT: 'Desactivada no es pot triar per a un esdeveniment nou.',
        CREATE: 'Crea la categoria',
        CREATED_TITLE: 'Categoria creada',
        SAVED_TITLE: 'Canvis desats',
        SAVE_ERROR: "No s'ha pogut desar la categoria.",
        ACTIVATE: 'Activa',
        ACTIVATE_TITLE: 'Activa «{{name}}»',
        ACTIVATE_TEXT: "Es podrà tornar a triar en donar d'alta un esdeveniment.",
        ACTIVATED: 'Activada',
        DEACTIVATE: 'Desactiva',
        DEACTIVATE_TITLE: 'Desactiva «{{name}}»',
        DEACTIVATE_TEXT: 'No es podrà triar per a esdeveniments nous. Els esdeveniments que ja la tenen la conserven.',
        DEACTIVATED: 'Desactivada',
        DELETE: 'Elimina la categoria',
        DELETE_TITLE: 'Elimina «{{name}}»',
        DELETE_TEXT: 'Només es poden eliminar les categories sense esdeveniments. No es pot desfer.',
        DELETED: 'Eliminada',
        DELETE_BLOCKED_TITLE: 'No es pot eliminar la categoria',
        DELETE_BLOCKED_BASE: 'És una de les 6 categories de sempre: desactiva-la en el seu lloc.',
        DELETE_BLOCKED_IN_USE: 'Té esdeveniments: desactiva-la en el seu lloc.',
        ACTION_ERROR: "No s'ha pogut completar l'acció",
      },
    },
  },
};
